import React from 'react';
import { styled } from 'baseui';
import { useStyletron } from 'baseui';
import { LabelSmall } from 'baseui/typography';
import type { HeaderInfoT } from '../../side-panel/annotations/types';
type PropsT = {
  label: string;
  headerInfo: HeaderInfoT;
  icon: React.ReactNode;
};
const Container = styled<'div', {
  $isVisible: boolean;
}>('div', ({
  $theme,
  $isVisible
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale500,
  opacity: $isVisible ? 1 : 0.5
}));
const LabelText = styled(LabelSmall, {
  margin: 0,
  '::first-letter': {
    textTransform: 'capitalize'
  },
  wordBreak: 'break-all'
});
export function HeaderContent({
  label,
  headerInfo,
  icon
}: PropsT) {
  const {
    isVisible
  } = headerInfo;
  const [css] = useStyletron();
  return <Container $isVisible={isVisible}>
      <span className={css({
      display: 'flex',
      alignItems: 'center'
    })}>{icon}</span>
      <LabelText>{label}</LabelText>
    </Container>;
}